/* OBSI – modellspezifischer Passform-Tipp, Fit-Skala-Hervorhebung + Grössentabellen-Sprung. */
(function () {
  var TIPPS = {
    'Heavyweight Oversize Shirt': 'Fällt bewusst oversize aus – grösser & weiter geschnitten. Trägst du normal M, sitzt M locker-weit; möchtest du es normal, wähl eine Nummer kleiner.',
    'Frauen Crop Shirt': 'Fällt kürzer & enger aus (Crop-Schnitt) – im Zweifel eine Nummer grösser. Druck-Hinweis: Wegen der kürzeren Länge ist der Print hier max. 27 cm hoch und fällt damit etwas kleiner aus als bei den anderen Modellen.',
    'Frauen Shirt': 'Oversize-Schnitt – fällt etwas weiter aus. Für einen körpernahen Sitz eine Nummer kleiner wählen.',
    'Bio-Baumwolle Shirt': 'Regular Fit – normal geschnitten. Nimm deine übliche Grösse.'
  };
  // Model-Referenz je Modell → wird als Chip unter dem Tipp gerendert.
  var MODELS = {
    'Heavyweight Oversize Shirt': { text: 'Model: 1,86 m · 78 kg', size: 'S' },
    'Frauen Crop Shirt': { text: 'Model: 1,74 m · 65 kg', size: 'M' },
    'Frauen Shirt': { text: 'Model: 1,74 m · 65 kg', size: 'S' },
    'Bio-Baumwolle Shirt': { text: 'Model: 1,86 m · 78 kg', size: 'M' }
  };

  function init(el) {
    if (el.dataset.fitInit) return;
    el.dataset.fitInit = '1';
    var scope = el.closest('product-info') || el.closest('.shopify-section') || document;
    var modelOut = el.querySelector('[data-fit-model]');
    var openBtn = el.querySelector('[data-fit-open]');
    var scaleItems = el.querySelectorAll('[data-fitscale-model]');

    function selectedModel() {
      var found = null;
      scope.querySelectorAll('input[type="radio"]:checked').forEach(function (i) {
        var v = (i.value || '').trim();
        if (TIPPS[v]) found = v;
      });
      scope.querySelectorAll('select').forEach(function (s) {
        var v = (s.value || '').trim();
        if (TIPPS[v]) found = v;
      });
      return found;
    }
    // Chips sektionsweit einsammeln (Galerie-Overlay liegt AUSSERHALB von [data-fit])
    var chipScope = el.closest('.shopify-section') || scope;
    var chips = Array.prototype.slice.call(chipScope.querySelectorAll('[data-fit-chip]'));
    function update() {
      var m = selectedModel();
      if (modelOut) {
        if (m && TIPPS[m]) { modelOut.textContent = TIPPS[m]; modelOut.hidden = false; }
        else { modelOut.hidden = true; }
      }
      chips.forEach(function (chip) {
        var chipText = chip.querySelector('[data-fit-chip-text]');
        var chipSize = chip.querySelector('[data-fit-chip-size]');
        if (!chipText || !chipSize) return;
        if (m && MODELS[m]) { chipText.textContent = MODELS[m].text; chipSize.textContent = MODELS[m].size; chip.hidden = false; }
        else { chip.hidden = true; }
      });
      scaleItems.forEach(function (it) {
        it.classList.toggle('is-active', it.getAttribute('data-fitscale-model') === m);
      });
    }
    scope.addEventListener('change', update);
    document.addEventListener('variant:change', update);
    update();
    setTimeout(update, 400);

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        var tbl = document.querySelector('.obsi-sizes');
        if (!tbl) return;
        var det = tbl.closest('details');
        if (det) det.open = true;
        tbl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }
  document.querySelectorAll('[data-fit]').forEach(init);
})();
